const Breadcrumb = ({ items, separator = '/' }) => (
    <nav aria-label="Breadcrumb">
        <ol className="flex flex-wrap p-4">
            {items.map((item, idx) => (
                <li key={idx} className="flex items-center">
                    {item.href ? (
                        <a href={item.href} className="text-[#49739c] text-base font-medium leading-normal">
                            {item.label}
                        </a>
                    ) : (
                        <span className="text-[#0d141c] text-base font-medium leading-normal">{item.label}</span>
                    )}
                    {idx < items.length - 1 && <span className="px-2 text-[#49739c]">{separator}</span>}
                </li>
            ))}
        </ol>
    </nav>
);

export default Breadcrumb;
